var render = function render(){
  var _vm$getValue;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', {
    class: _vm.wrapperClass,
    attrs: {
      "id": _vm.filterRowId
    },
    on: {
      "clear-filter": _vm.clearFilter
    }
  }, [_c('b-form-group', {
    class: _vm.labelClass,
    attrs: {
      "disabled": _vm.disable,
      "aria-disabled": _vm.disable,
      "id": _vm.filterLabelId,
      "label": _vm.labelIf,
      "label-for": _vm.filterId
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_vm.hasHovertip ? _c('div', {
          staticClass: "raftjs-hovertip"
        }, [_vm.hasHovertip ? _c('img', {
          staticStyle: {
            "height": "0.75rem",
            "padding-left": "0.5rem"
          },
          attrs: {
            "id": _vm.getHovertipId,
            "src": _vm.hovertipSrc,
            "alt": "help"
          }
        }) : _vm._e(), _vm._v(" "), _vm.hasHovertip ? _c('b-popover', {
          attrs: {
            "target": _vm.getHovertipId,
            "triggers": "hover focus"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("\n            " + _vm._s(_vm.getHovertipTitle) + "\n          ")];
            },
            proxy: true
          }], null, false, 3920097261)
        }, [_vm._v("\n          " + _vm._s(_vm.getHovertipText) + "\n        ")]) : _vm._e()], 1) : _vm._e()];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [!_vm.hideEmpty || (_vm$getValue = _vm.getValue) !== null && _vm$getValue !== void 0 && _vm$getValue.length ? _c('multi-select', {
    staticClass: "mr-sm-5 width-constraint",
    class: _vm.filterClass,
    attrs: {
      "show-labels": false,
      "id": _vm.filterId,
      "disabled": _vm.disable,
      "aria-disabled": _vm.disable,
      "value": _vm.bindValue,
      "options": _vm.getValue || [],
      "options-limit": _vm.optionsLimit,
      "custom-label": _vm.getLabel,
      "multiple": _vm.multiple,
      "placeholder": "",
      "required": _vm.isRequired,
      "track-by": _vm.trackBy,
      "allow-empty": !_vm.isRequired
    },
    on: {
      "input": _vm.updateFilter
    }
  }) : _vm._e(), _vm._v(" "), _vm.showClearButton ? _c('filter-clear-button', {
    attrs: {
      "id": _vm.filterId + '-clear-button'
    },
    on: {
      "click": _vm.clearFilter
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }